import { Component, OnInit } from '@angular/core';
import {LocalDataService} from "../services/local-data.service";
import { ActivatedRoute, Router } from '@angular/router';
import { ObservablepostService } from '../services/observablepost.service';
import { CredentialsService } from '../nservices/login/credentials.service';
import { SharedinfoService } from '../nservices/sharedinfo.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  no_access_field:boolean = false;
  fromsignup = false;

  constructor(private _credentialsS:CredentialsService,private _activRoute:ActivatedRoute,private _router:Router,
    private _sharedInfo:SharedinfoService) {
    // console.log("constructor del home");
      if(!this._credentialsS.getCredentialsAnonymous() && !this._credentialsS.getCredentials()){//trying to access to home manually or there is no valid token
        this._router.navigate(['login']);
      }
      else{
        this._activRoute.queryParams
            .subscribe(params =>{
              if(params['fromSignup']=="1"){
                this.fromsignup = true;
              }
            });
        this._activRoute.queryParams.subscribe(params =>{
          if(params['toback']=='1'){
            console.log("se recibio toback");
            this._sharedInfo.updatetoback(1);
          }
          else{
            this._sharedInfo.updatetoback(0);
          }
        });
      }
  }

  ngOnInit() {
    //console.log("ngOnInit del home");
    if(this.fromsignup){
      this.fromsignup=false;
      alert("Bienvenido a Time PlaceBook la letra u en tu usuario permanecera mientras se completa la evaluacion, puedes consultar mas informacion en la seccion About")
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/home/home.component.ts